module.exports = __webpack_public_path__ + "img/AO.1d553378.svg";